import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatabaseProvider } from '../../providers/database/database';
import { Subject } from 'rxjs';

@Component({
  selector: 'status-therapy-dialog',
  templateUrl: 'status-therapy-dialog.html'
})
export class StatusTherapyDialogComponent {
  private ngUnsubscribe: Subject<any> = new Subject();
  form: FormGroup;
  program_id: string;
  patient: any;
  user: any;
  therapy_status: any;
  therapy_substatus: any;
  therapy_type: any;
  therapy_statuses: any[] = [];
  therapy_substatuses: any[]= [];
  therapy_types: any[] = [];

  constructor(
    private db: DatabaseProvider,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<StatusTherapyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.createForm();

    this.patient = data.patient;
    this.program_id = data.program_id;
    this.db
    .getAdminSettings(this.program_id)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((settings) => {
      this.therapy_statuses = settings[0]['therapy_statuses'];
      this.therapy_types = settings[0]['therapy_type'];
      // data.patient.therapy_status = 'Discontinued';
      // data.patient.therapy_substatus = 'Deceased';
      // data.patient.therapy_type = "Commercial";
      // if (data.patient.therapy_status)  {
      //   this.therapy_status = data.patient.therapy_status;
      //   this.therapy_substatus = data.patient.therapy_substatus;
      //   this.therapy_type = data.patient.therapy_type;
      //   const substatuses = this.therapy_statuses.filter(item => item.status === this.therapy_status);
      //   if (this.therapy_status) {
      //     setTimeout(() => {
      //       console.log('updating substatus')
      //       this.onTherapyStatusChange(this.therapy_status)
      //     },3000);
      //   }
      //   const therapy =  {therapy_status: this.therapy_status, therapy_substatus: this.therapy_substatus, therapy_type: this.therapy_type};
      //   this.form.patchValue(therapy);
      // }
    });
  }

  ngOnInit() {

  }

  async createForm() {
    this.form = this.formBuilder.group({
      therapy_status: [null],
      therapy_substatus: [null],
      therapy_type: [null]
    });
  }

  ngOnDestroy() {
    console.log('Leave therapy dialog and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onTherapyStatusChange(value)  {
    console.log(value);
    const status = this.therapy_statuses.filter(item => item.status === value)
    console.log(status);
    if (status.length > 0)  {
      this.therapy_substatuses = status[0]['substatus'];
    }
  }

  submit() {
    let therapychange = this.form.value;
    console.log(therapychange);
    this.dialogRef.close(therapychange);
  }
}



// WEBPACK FOOTER //
// ./src/components/status-therapy-dialog/status-therapy-dialog.ts